var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("search-item", {
            ref: "searchItem",
            attrs: {
              "config-module": "19210",
              "expand-adv": true,
              "show-simple": false,
              "custom-search-items": _vm.customSearchItems
            },
            on: { advSearchItemCallBack: _vm.queryHandler }
          }),
          _c(
            "div",
            { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { height: "100%" },
                attrs: {
                  "config-module": "202506071",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "show-selected-color": false,
                  "check-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "202506071",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }